import React from 'react'
import style from "css/address.module.css";

function InfoPopupItem({ title, content }) {
    return (
        <div className={style.info_popup_item}>
            <p className={style.info_popup_item_title}>{title}</p>
            <div>{content}</div>
        </div>
    )
}

export default InfoPopupItem
